export const FETCH_LMS_USER_MANAGEMENT_USER_BY_ID_REQUEST = '@lms/userManagement/FETCH_USER_BY_ID_REQUEST';
export const FETCH_LMS_USER_MANAGEMENT_USER_BY_ID_SUCCESS = '@lms/userManagement/FETCH_USER_BY_ID_SUCCESS';
export const FETCH_LMS_USER_MANAGEMENT_USER_BY_ID_FAILURE = '@lms/userManagement/FETCH_USER_BY_ID_FAILURE';
